import React from 'react';
import { Modal } from 'antd';
import { OPTIMISATION_PRE_FLIGHT_CHECKS } from './utils';
import { PreflightCheckContainer, PreflightLoader } from './styles';

const CONFIRMATION_MESSAGE = 'Please check the information above is correct and as expected, then press confirm to begin optimisation.';
const DISABLED_MESSAGE = 'The parameters provided contain errors preventing optimisation. Close and correct these errors to optimise.';

const renderDescription = (Description) => {
  if (!Description) {
    return null;
  }
  return typeof Description === 'string' ? <p>{Description}</p> : <Description />;
};

const PreFlightOptimisationModal = ({
  loading, preflightCheckProps, onCancel, onSubmit,
}) => {
  const preflightChecks = OPTIMISATION_PRE_FLIGHT_CHECKS.map(c => c(preflightCheckProps));
  const confirmDisabled = preflightChecks.some(c => !!c.disableModal);
  return (
    <Modal
      title="Confirm Optimisation"
      visible
      onOk={onSubmit}
      okButtonProps={{ disabled: loading || confirmDisabled }}
      onCancel={onCancel}
      okText="Confirm"
      cancelText="Cancel"
      width={500}
    >
      {loading ? (
        <PreflightLoader
          type="sync"
          spin
        />
      ) : (
        <>
          {preflightChecks.map((check) => {
            const {
              title, description, displayPredicate, icon: CheckIcon,
            } = check;
            if (!displayPredicate) {
              return null;
            }
            return (
              <PreflightCheckContainer key={title}>
                <div>
                  {<CheckIcon />}
                </div>
                <aside>
                  <b>{title}</b>
                  {renderDescription(description)}
                </aside>
              </PreflightCheckContainer>
            );
          })}
          <p>
            {confirmDisabled ? DISABLED_MESSAGE : CONFIRMATION_MESSAGE}
          </p>
        </>
      )}
    </Modal>
  );
};

export default PreFlightOptimisationModal;
